import nfp from '../nativizeFoundationPromise.js'

let recaptchaLoadedPromise

Foundation.Form.ReCaptcha = class extends Foundation.View {
  static load () {
    if (recaptchaLoadedPromise) return recaptchaLoadedPromise

    const libUrl = 'https://www.google.com/recaptcha/api.js'
    const loadCallbackName = '_foundationRecaptchaLoaded'
    const libUrlWithOpts = `${libUrl}?onload=${loadCallbackName}&render=explicit`

    return recaptchaLoadedPromise = new Promise((resolve, reject) => {
      nfp(() => new Foundation.Script(libUrlWithOpts, true))
        .catch(err => {
          recaptchaLoadedPromise = undefined
          delete window[loadCallbackName]
          return reject(err)
        })

      window[loadCallbackName] = () => {
        delete window[loadCallbackName]
        return resolve()
      }
    })
  }

  constructor (elem) {
    super(elem)

    this.element.html(`
      <input type="hidden" name="recaptchaToken" value="" data-validate="recaptcha">
      <div class="g-recaptcha"></div>
    `)

    const recaptchaTokenInput = this.element.find('input').first()

    const recaptchaMountPoint = this.element.find('.g-recaptcha')[0]
    Foundation.Form.ReCaptcha.load().then(() => {
      this._recaptchaId = grecaptcha.render(recaptchaMountPoint, {
        badge: 'inline',
        sitekey: this.element.data('recaptcha-sitekey'),
        callback: token => { recaptchaTokenInput.val(token) },
        'expired-callback': () => { recaptchaTokenInput.val('') },
      })
    })
  }

  refresh () {
    grecaptcha.reset(this._recaptchaId)
  }
}

window['Foundation']['Form']['ReCaptcha'] = Foundation.Form.ReCaptcha
window['Foundation']['Form']['ReCaptcha']['load'] = Foundation.Form.ReCaptcha.load

/* global grecaptcha */
